export const PI2=Math.PI*2;
export const PIHALF=Math.PI*0.5;
export const PIFORTH=Math.PI*0.25;
export const SQRT1_2=Math.SQRT1_2;
export const SQRT2=Math.SQRT2;
export const D2R=Math.PI/180;
export const R2D=180/Math.PI;
